<template>
  <li
    @click="openDayAppointments()"
    class="calendar-day"
    :class="{
      'calendar-day--not-current': !day.isCurrentMonth,
      'calendar-day--today': isToday
    }"
    :style="returnStatusDay()"
  >
    <span class="day">{{ label }}</span>
    <div v-if="appointments && appointments.length > 0">
      <div v-for="appointment in sortByForecast(appointments)" :key="appointment.id" class="appointment">
        <div class="a-content"
             :class="{
               'a-present': appointment.status === 'present',
               'a-missed': appointment.status === 'missed'
             }">
          <img
            v-if="appointment.portal_service_json"
            class="mr-1"
            :src="require(`@/assets/calendar-fold${['present', 'missed'].includes(appointment.status) ? '-white' : ''}.svg`)"
          />
          <b class="mr-1">{{ formatToLocalDateTime(appointment.forecast) }}</b>
          |
          {{ appointment.title.toUpperCase() }}
        </div>
      </div>
    </div>
  </li>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import dayjs from "dayjs";

export default {
  name: "CalendarMonthDayItem",
  props: {
    appointments: {
      type: Array,
      required: false
    },
    services: {
      type: Array,
      required: false
    },
    day: {
      type: Object,
      required: true
    },
    isCurrentMonth: {
      type: Boolean,
      default: false
    },
    isToday: {
      type: Boolean,
      default: false
    },
    warningDay: {
      type: Object,
      required: false
    }
  },
  computed: {
    label() {
      return dayjs(this.day.date).format("D");
    }
  },
  methods: {
    openDayAppointments() {
      this.$emit('open-day-appointments', {date: this.day.date, appointments: this.appointments});
    },
    returnStatusDay() {
      const percent = ((this.services.length / this.warningDay.full) * 100).toFixed();
      if (this.services.length >= this.warningDay.full) {
        return `background-image: linear-gradient(180deg, #fff ${ percent > 100 ? 0 : 100 - percent }%, rgba(237, 67, 70, 0.1) 0%)`;
      } if(this.services.length >= this.warningDay.almost_full)  {
        return `background-image: linear-gradient(180deg, #fff ${percent > 100 ? 0 : 100 - percent }%, rgba(254, 205, 47, 0.2) 0%)`;
      }
      return `background-image: linear-gradient(180deg, #fff ${ 100 - percent }%, rgba(40, 218, 102, 0.1) 0%)`;
    },
    formatToLocalDateTime(dateString) {
      const date = new Date(dateString);
      return date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    sortByForecast(array) {
      return array.sort((a, b) => new Date(a.forecast) - new Date(b.forecast));
    }
  }
};
</script>

<style scoped lang="scss">
.calendar-day {
  position: relative;
  min-height: 120px;
  font-size: 16px;
  background-color: #fff;
  color: rgba(0, 0, 0, 0.6) ;
  padding: 5px;
  cursor: pointer;

  .appointment {
    display: grid;
    padding-bottom: 3px;

    .a-content {
      cursor: pointer;
      font-size: 13px;
      white-space: nowrap;
      overflow: hidden;
      margin: 0px 6px 3px 6px;
      border: 1px solid #d2d2d2;
      border-radius: 4px;
      padding: 0px 3px;
      display: flex;
    }

    .a-present {
      background-color: #48b38b;
      border: 1px solid green !important;
      color: #fff;
    }
    .a-missed {
      background-color: #e57373;
      border: 1px solid red !important;
      color: #fff;
    }
  }
}

.calendar-day > .day {
  display: flex;
  justify-content: center;
  margin: 4px auto;
  width: 23px;
  height: 23px;
  font-weight: bold;
}

.calendar-day--not-current {
  background-color: rgb(245, 245, 245);
  color: rgba(0, 0, 0, 0.3) ;
}

.calendar-day--today {
  padding-top: 4px;
}

.calendar-day--warning {
  background-color: yellow;
}

.calendar-day--danger {
  background-color: red;
}

.calendar-day--today > .day {
  color: #fff;
  border-radius: 9999px;
  background-color: #48B38B;
}
</style>
